import React, { Fragment } from 'react';
import T from 'prop-types';
import isEmpty from 'lodash/isEmpty';

import { CheckboxWithText, ConditionalRender } from '../../../base_ui';
import { FormInputs } from '../../sharedComponents/PaymentSource';
import { ClearButton, UseExistingContainer } from './styledComponents';

const AccountForm = ({
  accountForm,
  formErrors,
  formValues,
  handleDispatchClearNewInfo,
  handleDispatchSetInput,
  handleDispatchSetUseExisting,
  handleValidatePress,
  infoExisting,
  infoNew,
  isValidateButtonDisabled,
  useExistingInfo,
  useNewInfo,
}) => (
  <Fragment>
    <ConditionalRender
      Component={(
        <UseExistingContainer>
          <CheckboxWithText
            checked={useExistingInfo}
            onPress={() => handleDispatchSetUseExisting({
              accountForm,
              value: !useExistingInfo,
            })}
            title="Use Existing Account Information"
          />
        </UseExistingContainer>
      )}
      shouldRender={!isEmpty(infoExisting)}
    />
    <FormInputs
      disableInputs={useExistingInfo || useNewInfo}
      dispatchSetInput={handleDispatchSetInput}
      formErrors={formErrors}
      formValues={formValues}
      handleValidatePress={handleValidatePress}
      isValidateButtonDisabled={isValidateButtonDisabled}
    />
    <ConditionalRender
      Component={ClearButton}
      propsToPassDown={{
        label: 'Clear',
        onPress: () => handleDispatchClearNewInfo(accountForm),
      }}
      shouldRender={!isEmpty(infoNew) && !useExistingInfo}
    />
  </Fragment>
);

AccountForm.propTypes = {
  accountForm: T.string.isRequired,
  formErrors: T.object.isRequired,
  formValues: T.object.isRequired,
  handleDispatchClearNewInfo: T.func.isRequired,
  handleDispatchSetInput: T.func.isRequired,
  handleDispatchSetUseExisting: T.func.isRequired,
  handleValidatePress: T.func.isRequired,
  infoExisting: T.object.isRequired,
  infoNew: T.object.isRequired,
  isValidateButtonDisabled: T.bool.isRequired,
  useExistingInfo: T.bool.isRequired,
  useNewInfo: T.bool.isRequired,
};

export default AccountForm;
